var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{attrs:{"id":"map","center":_vm.center,"zoom":13,"options":_vm.options,"map-type-id":"terrain"}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"clickable":true,"draggable":false,"icon":{
      url: m.icon
    }},on:{"click":function($event){return _vm.markerClicked(m)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }